import React from 'react';
import dynamic from 'next/dynamic';
import { observer, useStoreState } from 'base/store';
import PageHeader, { IPageHeaderProps } from 'app/components/common/PageHeader';
import PageFooter, { IPageFooterProps } from 'app/components/common/PageFooter';
import CheckoutHeader from '@app/common/CheckoutLayout/CheckoutHeader';
import { Copyright } from '@base/common/Copyright';
import DefaultLoading from '@base/common/DefaultLoading';
import styles from './index.module.less';
import SideWidgets from '@app/common/SideWidgets';
import FloatMiniEntrance from '@base/common/FloatMiniEntrance';
import { IOpeningPopupProps, OpeningPopup } from '@base/common/OpeningPopup';
import AgeGatePopup from '@pro/age-gate/AgeGatePopup';

const GoogleOneTapLogin = dynamic(() => import('@base/GoogleOneTapLogin'), { ssr: false });

export type BaseLayoutProps = IPageHeaderProps & {
    loading?: boolean;
    showSideWidgets?: boolean;
    footer?: React.ReactElement | false;
    footerProps?: IPageFooterProps;
    openingPopupProps?: IOpeningPopupProps;
};

const BaseLayout: React.FC<BaseLayoutProps> = (props) => {
    const {
        loading: propsLoading,
        headerProps,
        showSideWidgets = true,
        footer,
        footerProps,
        openingPopupProps,
    } = props
    const { pageLoading, pageLayout, showOpeningPopup = true } = useStoreState('rootStore');
    const loading = propsLoading || pageLoading;
    const isDefaultLayout = pageLayout === 'default';

    return (
        <div className={styles[`layout-${pageLayout}`]}>

            {/* Google One Tap 一键式登录 */}
            <GoogleOneTapLogin />

            {isDefaultLayout ? (
                <PageHeader headerProps={headerProps}/>
            ) : (
                <CheckoutHeader/>
            )}

            {/* 年龄限制弹窗 */}
            <AgeGatePopup pageProps={(props.children as any)?.props}/>

            {loading ? <DefaultLoading type="page"/> : props.children}

            {footer === false ? null : (footer || (isDefaultLayout ? <PageFooter {...footerProps}/> : <Copyright className={styles.copyright}/>))}

            {showSideWidgets && <SideWidgets/>}

            <FloatMiniEntrance/>

            {isDefaultLayout && showOpeningPopup && <OpeningPopup {...openingPopupProps}/>}
        </div>
    );
}

export default observer(BaseLayout);
